const styles = {
  root: {
  },
  btn: {
    height: '40px',
    mt: 2,
  },
  whatsLink: {
    textDecoration: 'none',
  },
  divider: {
    width: '100%',
    mb: 6,
  },
  containerComp: {
    p: 2,
  },
  scheduleContainer: {
    display: 'flex',
  },
  dateItem: {
    ml: 0.5,
  },
  imageSwiper: {
    '& .swiper': {
      width: '100%',
      height: {
        xs: 300, md: 250, lg: 364, xl: 364,
      },
    },
    pl: { xs: 0, sm: 0.5 },
    pr: { xs: 0, sm: 0.5 },
    mb: { xs: 2, sm: 0 },
  },

  mapAndGallery: {
    display: 'flex',
  },

  branchTitle: {
    my: 2,
    '&.MuiPaper-root-MuiAccordion-root:before': {
      backgroundColor: 'rgba(0, 0, 0, 0)!important',
    },
  },

  accordionVDP: {
    border: '1px solid #f1f1f1',
    p: 1,
    my: 2,
    '&.MuiPaper-root-MuiAccordion-root:before': {
      backgroundColor: 'rgba(0, 0, 0, 0)!important',
    },
  },
  btnsContainers: {
    mb: 1,
  },
}

export default styles
